import { TICK_MS } from '@constants/timing';
import { clockTime, longDate, shortDay } from '@lib/format';
import { useTick } from '@lib/hooks';

/** Running clock in WIB (the business day of the whole system); only this small element re-renders. */
export function WibClock() {
  useTick(TICK_MS.clock);
  const now = new Date();
  return (
    <time className="clock" dateTime={now.toISOString()} title={`${longDate(now)}, waktu Indonesia Barat`}>
      <span className="clock-day">{shortDay(now)}</span>
      <span className="clock-time">{clockTime(now)}</span>
      <span className="clock-zone">WIB</span>
    </time>
  );
}
